import { Link } from "react-router-dom";
import { Clock3 } from "lucide-react";

export default function CguPlaceholder() {
    return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-24 text-center" data-testid="page-cgu">
            <Clock3 className="h-8 w-8 text-brand-orange" />
            <h1 className="mt-6 font-display text-5xl font-normal tracking-tightest">
                Conditions Générales <em className="italic text-brand-smoke">bientôt</em>.
            </h1>
            <p className="mt-6 max-w-md text-brand-ink/70">
                Les conditions générales d'utilisation seront publiées avant l'ouverture des inscriptions en ligne (Phase 4).
            </p>
            <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white">
                Retour au site
            </Link>
        </div>
    );
}
